import type { TimestampedAssemblyAITurnMessage } from "@/domains/dexie-db/audio-capture/types";
import type { ParsedTranscriptEvent, ParsedTranscriptWord } from "./desktop-event-parser";

export type DesktopTurnUpdate = {
  turn: TimestampedAssemblyAITurnMessage;
};

export class DesktopTranscriptAssembler {
  /**
   * Turn order is shared amongst both sides and just continuously increases.
   */
  private turnOrder: number;

  constructor() {
    this.turnOrder = 0;
  }

  reset() {
    this.turnOrder = 0;
  }

  ingest({ event }: { event: ParsedTranscriptEvent }): DesktopTurnUpdate | null {
    const turnOrder = this.turnOrder;

    const words = this.cloneWords(event.words);

    const turn: TimestampedAssemblyAITurnMessage = {
      type: "Turn",
      turn_order: turnOrder,
      turn_is_formatted: false,
      end_of_turn: event.endOfTurn,
      transcript: event.transcript,
      end_of_turn_confidence: event.endOfTurn ? 1 : 0,
      words,
      timestamp: event.timestamp,
    };

    if (event.endOfTurn) {
      this.turnOrder = turnOrder + 1;
    }

    return { turn };
  }

  private cloneWords(words: ParsedTranscriptWord[]): TimestampedAssemblyAITurnMessage["words"] {
    return words.map(word => ({
      text: word.text,
      start: word.start,
      end: word.end,
      confidence: word.confidence,
    }));
  }
}
